<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="time"
        prepend-inner-icon="event"
        :style="textStyle"
        :label="label"
        :solo="solo"
        :shaped="shaped"
        :hide-details="hideDetails"
        :rounded="rounded"
        :rules="rules"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="time"
      @input="$emit('on:date-selected', time)"
      @change='datepickerChange'
      :required="required"
      no-title
      scrollable
      locale="tr">
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DateMonthPicker',
  props: {
    rules: Array,
    label: {},
    required: { default: () => false },
    solo: { default: () => false },
    shaped: { default: () => false },
    hideDetails: { default: () => false },
    rounded: { default: () => false },
    textStyle: { default: () => '' },
    default: {
      type: Function,
      default: () => '',
    },
  },
  data: () => ({
    menu: false,
    date: new Date().toJSON()
      .replace('T', ' ')
      .substr(0, 16),
    time: '',
  }),
  watch: {
    default(nv) {
      if (this.default() !== '') {
        this.time = nv();
      }
    },
  },
  methods: {
    datepickerChange(date) {
      this.$refs.menu.save(date);
    },
  },
};
</script>
